import { Price } from '@ds'

import { Card as BattlePassCard } from '../../battlePass/components/Card'
import { Discount } from '../discount'

import styles from './Booster.module.scss'
export const Booster = ({
  price,
  movementAnimationDelay,
  imgPath,
  title,
  onClick,
  free
}: {
  title: string
  price: number
  imgPath: string
  movementAnimationDelay: number
  onClick: () => void
  free?: string
}) => {
  return (
    <div onClick={onClick} className={styles.container}>
      {free && (
        <Discount discount={free} />
      )}
      <BattlePassCard
        className={styles.card}
        movementAnimationDelay={movementAnimationDelay}
        title={title}
        index={0}
      >
        <img src={imgPath} className={styles.booster} />
      </BattlePassCard>
      <Price className={styles.price} value={price} />
    </div>
  )
}
